import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const InternalNotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/", { replace: true });
  });

  return null;
};
